import type { ButtonProps } from "antd";

import { Button } from "antd";
import { useTranslation } from "react-i18next";

import {
  useDatasetsMutatorActions,
  useDatasetsMutatorStatus,
} from "@/modules/datasets/datasets-mutator";
import { useInterventionSectionRenderIndex } from "@/modules/intervention/intervention-section";

const DatasetsMutatorCancelButton = ({
  onClick,
  ...buttonProps
}: ButtonProps) => {
  const { t } = useTranslation();
  const { isDirty } = useDatasetsMutatorStatus();
  const { cancelMutations } = useDatasetsMutatorActions();
  const { incrementIndex } = useInterventionSectionRenderIndex();

  if (!isDirty) return;

  const onButtonClick: ButtonProps["onClick"] = (e) => {
    cancelMutations();
    incrementIndex();
    onClick?.(e);
  };

  return (
    <Button {...buttonProps} onClick={onButtonClick}>
      {t("global:cancel")}
    </Button>
  );
};

export default DatasetsMutatorCancelButton;
